class ConsoleLogger {
  constructor(game, scene, config, id) {
    this.id = id;
  }

  log(...args) {
    if (__DEBUG__) {
      console.log(...args);
    }
  }

  getLoggerVisibility() {}

  setLoggerVisibility(value) {}

  updatePosition() {}

  destroy() {}
}

export { ConsoleLogger };
